import { STATIC_STORAGE_URL } from '@nexxt/common/constants';
import * as React from 'react';
import NotifyHOC from '../../../HOC/Notifications';
import { sendFeedback } from '../../../services/client.service';

function FeedbackPopup(props) {
    const { title, text, close, toastNotification } = props;
    const [feedbackInput, setFeedbackInput] = React.useState('');
    const [sent, setSent] = React.useState(false);

    const submitFeedback = async () => {
        try {
            if (feedbackInput === '') {
                toastNotification.error(
                    'Please enter your message into the text field.'
                );
            } else {
                await sendFeedback({
                    message: feedbackInput,
                    subject: 'General Feedback'
                });

                setSent(true);
            }
        } catch (error) {
            toastNotification.error(
                'Failed to send feedback. Refresh and try again.'
            );
        }
    };

    return (
        <div className="feedback-popup">
            <i className="nx nx-close" onClick={close} />
            <h1 className="title">{title}</h1>
            <p>{text}</p>
            {!sent && (
                <>
                    <textarea
                        className="feedback-input"
                        placeholder="What's going on?"
                        value={feedbackInput}
                        onChange={(e) => setFeedbackInput(e.target.value)}
                    />
                    <button
                        className="btn btn--sm btn--green"
                        onClick={submitFeedback}
                    >
                        Submit
                    </button>
                </>
            )}
            {sent && (
                <div className="sent-msg">
                    <img
                        src={`${STATIC_STORAGE_URL}/img/circled-checkmark.svg`}
                        alt="Message Sent Icon"
                    />
                    <h1 className="title">Your message has been sent.</h1>
                    <p>We will get back to you as soon as possible.</p>
                </div>
            )}
        </div>
    );
}

export default NotifyHOC(FeedbackPopup);
